import { render, staticRenderFns } from "./Allowed-Leave.vue?vue&type=template&id=3ba8b0e7"
import script from "./Allowed-Leave.vue?vue&type=script&lang=js"
export * from "./Allowed-Leave.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports